export const readStoredJson = key => {
  const raw = localStorage.getItem(key)
  if (raw === null) return null

  try {
    return JSON.parse(raw)
  } catch (error) {
    localStorage.removeItem(key)
    return null
  }
}

export const writeStoredJson = (key, value) => {
  if (value === undefined || value === null) {
    localStorage.removeItem(key)
    return
  }

  localStorage.setItem(key, JSON.stringify(value))
}
